import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchSearch } from '../api/newsService';
import { TitleComponent } from './TitleDocument';
import Sidebar from './Sidebar/Sidebar';
import DOMPurify from 'dompurify';
import BreadCrumb from './BreadCrumb';


const SearchDetail = () => {
    const { postId } = useParams();
    const [post, setPost] = useState({});
    useEffect(() => {
        const search = async () => {
            const res = await fetchSearch({id:postId});
           
            if(res && res.data && res.data.data.lstNews){
                setPost(res.data.data.lstNews)
              }
          };
          search();
          
        }, [postId]);
        const sanitizeHTML = (html) => {
          return { __html: DOMPurify.sanitize(html) };
      };
    return (
     <section className='news_detail container'>
     <div className='new_detail_content'>
     <div className='content'>
     
     {post && post.length > 0 &&
       (post
       .filter(detail => detail.id === parseInt(postId))
       .map(detail => (
         
         <div key={detail.id}>
         <div className='path'>
                <BreadCrumb
                  caseCondition = 'case3'
                />
              </div>
         <TitleComponent title={detail.title}/>
           <h1>{detail.title}</h1>
           <div dangerouslySetInnerHTML={sanitizeHTML(detail.content)} className='descrip'></div>
         </div>
       ))
)}
     </div>
     <div className='sidebar_newdetail'><Sidebar/></div>
   </div>
     </section>
    );
  }

export default SearchDetail
